export default "__VITE_ASSET__C25Y9zSH__"